/**
 * Uses the same logic used in the main repo to redact an account number.
 * Returns a string with, at most, the last 4 digits of the account number,
 * but less if account number is less than 8 digits long.  Rest of digits
 * prepended with *.
 */
export const redactAccountNumber = (accountNumber: string): string => {
  const lenToShow = Math.min(Math.floor(accountNumber.length / 2), 4);

  const maskedPart = "*".repeat(accountNumber.length - lenToShow);
  const unmaskedPart = accountNumber.substring(accountNumber.length - lenToShow);

  return maskedPart + unmaskedPart;
};
